import * as _ from "lodash";
import * as $ from "jquery";
import * as moment from "moment-timezone";
import {UserGroupCollection} from "../../../collections/UserGroups";
import {UserCollection} from "../../../collections/Users";
import {BaseList, TableProperties} from "../../_BaseList";
import * as Backbone from "backbone";
import {InstallCollection} from "../../../collections/Installs";
import {DashboardChannelCollection} from "../../../collections/DashboardChannels";
import {PermissionCollection} from "../../../collections/Permissions";
import {BaseCollection} from "../../../collections/_BaseCollection";
import {ModuleCollection} from "../../../collections/Modules";
import {BaseDetailAccountView, BaseDetailAccountViewOptions} from "../_BaseAccountViews";


export interface ReportDetailViewOptions extends BaseDetailAccountViewOptions {
    currentReport: Backbone.Model;
    groupPermissionCollections: { [groupId: number]: PermissionCollection };
    dashboardChannelCollection: DashboardChannelCollection;
}

abstract class BaseReportDetailView extends BaseDetailAccountView {
    options: ReportDetailViewOptions;

    constructor(options: ReportDetailViewOptions) {
        super(options);
    }
}

export class ReportTeamView extends BaseReportDetailView {

    constructor(options: ReportDetailViewOptions) {
        super(<any> _.extend({}, options, {
            tagName: 'div',
            events: {
                'click .add-user-team-button': 'handleCreateUserButtonClick',
                'click .delete-from-list': 'handleDeleteUserGroupUser',
            }
        }));
    }

    render() {
        var url = '/#/account/' + this.options.currentOrganizationId + '/reports/' +
            this.options.currentReport.get('id') + '/teams';
        var footer = this.options.isOverview ? {text: 'View All', url: url} : null;

        this.$el.html(this.template({
            panelTitle: {text: 'Teams with access to this Report', url: this.options.isOverview ? url : null},
            panelClass: 'teams',
            panelWidth: '',
            addButton: null,
            search: !this.options.isOverview,
            collectionLoaded: this.collectionLoaded,
            footer: footer
        }));
        return this;
    }

    show() {
        var deferreds = this.options.userGroupCollection.map((g) => {
            var id = g.get('id');
            if (!this.options.groupPermissionCollections[id]) {
                this.options.groupPermissionCollections[id] = new PermissionCollection([], {userGroupId: id});
            }
            return this.options.groupPermissionCollections[id].getCollectionFetchPromise();
        });

        $.when.apply($, deferreds).done(() => {
            this.collectionLoaded = true;
            this.render();
            this.showTable();
            (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        });
    }

    showTable() {
        var teamTable = new BaseList(this.options);
        var teamTableProperties: TableProperties;
        teamTableProperties = {
            tableEmptyText: 'There are no Teams with access',
            rowUrl: '#/account/' + this.options.currentOrganizationId + '/teams/',
            columnProperties: {
                'Team Name': {
                    attribute: 'name',
                    columnSizes: {
                        'sm': '5',
                        'md': '5',
                        'xs': '12'
                    }
                },
                'Permissions': {
                    customColumn: {
                        templateFunction: _.template(
                            '<% var perms = []; %>' +
                            '<% if(groupPermissionCollections[mod.get("id")].canViewReport(reportId)) perms.push("View")%>' +
                            '<% if(groupPermissionCollections[mod.get("id")].canModifyReport(reportId)) perms.push("Modify") %>' +
                            '<% if(groupPermissionCollections[mod.get("id")].canDeleteReport(reportId)) perms.push("Delete") %>' +
                            ' <div class="col-md-6 col-sm-6 col-xs-10">' +
                            '<% if(perms.length) { %>' +
                            '<%- perms.join(", ") %>' +
                            '<% } else { %>' +
                            '<%- "None" %>' +
                            '<% }  %>' +
                            ' </div>'),
                        variables: {
                            groupPermissionCollections: this.options.groupPermissionCollections,
                            reportId: Number(this.options.currentReport.get('id')),
                        }
                    },
                    columnSizes: {
                        'sm': '6',
                        'md': '6',
                        'xs': '10'
                    }
                }
            }
        };

        if (this.options.isOverview) {
            teamTableProperties['limitedRows'] = {
                count: 3,
                sortBy: 'is_admin',
                reverseSort: true,
                collectionProperties: {
                    organizationId: this.options.currentOrganizationId
                }
            };
        }
        var teams = this.options.userGroupCollection.filter((team) => {
            return this.options.currentReport.get('organization_id') === team.get('organization_id')
                && this.options.groupPermissionCollections[team.get('id')].canViewReport(Number(this.options.currentReport.get('id')))
        });
        var userGroupCollection = new UserGroupCollection(teams, {organizationId: this.options.currentOrganizationId});
        userGroupCollection.sort();
        this.$('.teams .panel-body > .row').empty().append(
            teamTable.renderCollectionList(userGroupCollection, teamTableProperties).$el
        );
    }
}

export class ReportUserView extends BaseReportDetailView {

    render() {
        var url = '/#/account/' + this.options.currentOrganizationId + '/reports/' +
            this.options.currentReport.get('id') + '/users';
        var footer = this.options.isOverview ? {text: 'View All', url: url} : null;

        this.$el.html(this.template({
            panelTitle: {text: 'Users with access to this Report', url: this.options.isOverview ? url : null},
            panelClass: 'users',
            panelWidth: '',
            addButton: null,
            search: !this.options.isOverview,
            collectionLoaded: this.collectionLoaded,
            footer: footer
        }));
        return this;
    }

    show() {
        var deferreds = this.options.userGroupCollection.map((g) => {
            var id = g.get('id');
            if (!this.options.groupPermissionCollections[id]) {
                this.options.groupPermissionCollections[id] = new PermissionCollection([], {userGroupId: id});
            }
            return this.options.groupPermissionCollections[id].getCollectionFetchPromise();
        });

        $.when.apply($, deferreds).done(() => {
            this.collectionLoaded = true;
            this.render();
            this.showTable();
            (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        });
    }

    showTable() {
        var usersTable = new BaseList(this.options);
        var usersTableProperties: TableProperties;
        usersTableProperties = {
            rowUrl: '#/account/' + this.options.currentOrganizationId + '/users/',
            tableEmptyText: 'There are no Users with access',
            columnProperties: {
                'Name': {
                    attribute: 'name',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Email': {
                    attribute: 'email',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Phone Number': {
                    attribute: 'phone_number',
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                },
                'Permissions': {
                    attribute: 'usergroups',
                    customColumn: {
                        templateFunction: _.template('<% var perms = []; %> ' +
                            ' <% _.each(mod.get("usergroups"), function(g, id) { %> ' +
                            ' <% var uGroup  = userGroupCollection.findWhere({id: Number(id)}) %>' +
                            ' <% if(groupPermissionCollections[uGroup.get("id")].canViewReport(reportId)) perms.push("View")%>' +
                            ' <% if(groupPermissionCollections[uGroup.get("id")].canModifyReport(reportId)) perms.push("Modify")%>' +
                            ' <% if(groupPermissionCollections[uGroup.get("id")].canDeleteReport(reportId)) perms.push("Delete")%>' +
                            ' <% }); %>' +
                            ' <div class="col-md-3 col-sm-2 col-xs-10 account-modify-team-member-since">' +
                            ' <%- _.uniq(perms).join(", ") %>' +
                            ' </div>'
                        ),
                        variables: {
                            userGroupCollection: this.options.userGroupCollection,
                            groupPermissionCollections: this.options.groupPermissionCollections,
                            reportId: Number(this.options.currentReport.get('id')),
                        }
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '10'
                    }
                }
            }
        };

        if (this.options.isOverview) {
            usersTableProperties['limitedRows'] = {
                count: 3,
                sortBy: 'name',
                reverseSort: false,
                collectionProperties: {
                    organizationId: this.options.currentOrganizationId
                }
            };
        }

        var users = this.options.userCollection.filter((user) => {
            var canView = false;
            _.each(user.get('usergroups'), (uGroup, id) => {
                var reportId = Number(this.options.currentReport.get('id'));
                if (this.options.groupPermissionCollections[Number(id)].canViewReport(reportId)) {
                    canView = true;
                    return false;
                }
            });

            return canView;
        });
        var userCollection = new UserCollection(users, {organizationId: this.options.currentOrganizationId});
        this.$('.users .panel-body > .row').append(
            usersTable.renderCollectionList(userCollection, usersTableProperties).$el
        );
    }
}

export class ReportInstallView extends BaseReportDetailView {

    private moduleCollections: { [installId: number]: ModuleCollection } = {};

    render() {
        var url = '/#/account/' + this.options.currentOrganizationId + '/reports/' +
            this.options.currentReport.get('id') + '/installs';
        var footer = this.options.isOverview ? {text: 'View All', url: url} : null;

        this.$el.html(this.template({
            panelTitle: {text: 'Installations used on this Report', url: this.options.isOverview ? url : null},
            panelClass: 'installs',
            panelWidth: '',
            addButton: null,
            search: !this.options.isOverview,
            collectionLoaded: this.collectionLoaded,
            footer: footer
        }));
        return this;
    }

    private getRelevantInstalls() {
        var viewableInstalls = _.uniq(_.flatten(this.options.userGroupCollection.map((g) => {
            return this.options.groupPermissionCollections[g.get('id')].getViewableInstallIds()
        })));

        var reportInstalls = _.uniq(this.options.dashboardChannelCollection.map((m) => {
            return m.get('install_id')
        }));
        return _.intersection(viewableInstalls, reportInstalls);
    }

    show() {
        var deferreds = this.options.userGroupCollection.map((g) => {
            var id = g.get('id');
            if (!this.options.groupPermissionCollections[id]) {
                this.options.groupPermissionCollections[id] = new PermissionCollection([], {userGroupId: id});
            }
            return this.options.groupPermissionCollections[id].getCollectionFetchPromise();
        });

        deferreds.push(this.options.dashboardChannelCollection.getCollectionFetchPromise());

        $.when.apply($, deferreds).then(() => {
            deferreds = _.map(this.getRelevantInstalls(), (installId) => {
                this.moduleCollections[installId] = new ModuleCollection([], {installId: installId});
                return this.moduleCollections[installId].fetch();
            });
            return $.when.apply($, deferreds)
        }).done(() => {
            this.collectionLoaded = true;
            this.render();
            this.showTable();
            (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        });
    }

    showTable() {
        var getInstallModifiedDate = function (install, modCols) {
            var dates = [moment(install.get('modified')).format("L")];
            var modDate = 0;
            modCols[install.get('id')].each((modCol) => {
                if (modCol.get('module_modified') > modDate) modDate = modCol.get('module_modified')
            });
            if (modDate !== 0) dates.push(moment.unix(modDate).format("L"));

            dates = _.sortBy(dates, (date) => {
                return date;
            }).reverse();

            return _.first(dates);
        };

        var installTable = new BaseList(this.options);
        var installTableProperties: TableProperties = {
            tableEmptyText: 'There are no Installations used on this Report',
            columnProperties: {
                'Install Name': {
                    customColumn: {
                        templateFunction: _.template(' <div class="col-md-3 col-sm-3 col-xs-10">' +
                            ' <%- mod.getDisplayName() %>' +
                            ' </div>')
                    },
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Address': {
                    customColumn: {
                        templateFunction: _.template(' <div class="col-md-2 col-sm-2 col-xs-10">' +
                            ' <%- mod.getDisplayAddress() ? mod.getDisplayAddress() : "" %>' +
                            ' </div>')
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                },
                'Gateway Serial Number': {
                    attribute: 'name',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Created': {
                    centerColumn: true,
                    customColumn: {
                        templateFunction: _.template('<% var inviteDate = mod.get("created") ? mod.get("created") : null %> ' +
                            ' <% if(inviteDate){ %> ' +
                            ' <div class="col-md-2 col-sm-2 col-xs-10 text-center"><%- moment(inviteDate).format("L") %></div>' +
                            ' <% }else{ %>' +
                            ' <div class="col-md-2 col-sm-2 col-xs-10 text-center">' +
                            ' ' +
                            ' </div>' +
                            ' <% } %>'),
                        variables: {
                            moment: moment
                        }
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '10'
                    }
                },
                'Modified': {
                    centerColumn: true,
                    customColumn: {
                        templateFunction: _.template(
                            '<% var inviteDate = getInstallModifiedDate(mod, modCols) %>' +
                            ' <div class="col-md-2 col-sm-2 col-xs-10 text-center"><%- inviteDate ? inviteDate : "" %></div>'),
                        variables: {
                            moment: moment,
                            getInstallModifiedDate: getInstallModifiedDate,
                            modCols: this.moduleCollections
                        }
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '10'
                    }
                }
            }
        };

        if (this.options.isOverview) {
            installTableProperties['limitedRows'] = {
                count: 3,
                sortBy: 'name',
                reverseSort: false,
                collectionProperties: {
                    organizationId: this.options.currentOrganizationId
                }
            };
        }

        var relevantInstalls = this.getRelevantInstalls();
        var installCollection = new InstallCollection(this.options.installCollection.filter((i) => {
            return _.includes(relevantInstalls, i.get('id'))
                && i.get('organization_id') === this.options.currentOrganizationId
        }));
        this.$('.installs .panel-body > .row').empty().append(
            installTable.renderCollectionList(installCollection, installTableProperties).$el
        );
    }
}

export class ReportChannelView extends BaseReportDetailView {

    render() {
        var url = '/#/account/' + this.options.currentOrganizationId + '/reports/' +
            this.options.currentReport.get('id') + '/channels';
        var footer = this.options.isOverview ? {text: 'View All', url: url} : null;

        this.$el.html(this.template({
            panelTitle: {text: 'Channels on this Report', url: this.options.isOverview ? url : null},
            panelClass: 'channels',
            panelWidth: '',
            addButton: null,
            search: !this.options.isOverview,
            collectionLoaded: this.collectionLoaded,
            footer: footer
        }));
        return this;
    }

    show() {
        $.when(this.options.dashboardChannelCollection.getCollectionFetchPromise()).done(() => {
            this.collectionLoaded = true;
            this.render();
            this.showTable();
            (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        });
    }

    showTable() {
        var reportChannelTable = new BaseList(this.options);
        var reportChannelTableProperties: TableProperties = {
            tableEmptyText: 'There are no Channels on this Report',
            columnProperties: {
                'Name': {
                    attribute: 'report_channel_name',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Install': {
                    customColumn: {
                        templateFunction: _.template(' <div class="col-md-3 col-sm-3 col-xs-10">' +
                            ' <%- installCollection.findWhere({id: mod.get("install_id")}) ? installCollection.findWhere({id: mod.get("install_id")}).getDisplayName(): "" %>' +
                            ' </div>'),
                        variables: {
                            installCollection: this.options.installCollection
                        }
                    },
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Location': {
                    attribute: 'module_location',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Sensor': {
                    customColumn: {
                        templateFunction: _.template(' <div class="col-md-2 col-sm-2 col-xs-10">' +
                            ' <% if(mod.get("module_is_gateway")) { %>' +
                            ' <span class="badge">•</span>' +
                            ' <% } else { %>' +
                            ' <span class="badge">••••</span>' +
                            ' <% } %>' +
                            '  <%- " "+mod.get("sensor_name") %>' +
                            ' </div>')
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                },
                'Unit': {
                    centerColumn: true,
                    attribute: 'channel_unit',
                    columnSizes: {
                        'sm': '1',
                        'md': '1',
                        'xs': '12'
                    }
                },

            }
        };

        var channelCollection = new DashboardChannelCollection(this.options.dashboardChannelCollection.models);
        channelCollection.comparator = (model) => {
            return model.get('report_channel_name');
        };
        channelCollection.sort();

        if (this.options.isOverview) {
            reportChannelTableProperties['limitedRows'] = {
                count: 3,
                sortBy: 'report_channel_name',
                reverseSort: false,
                collectionProperties: {
                    organizationId: this.options.currentOrganizationId
                }
            };
        }
        this.$('.channels .panel-body > .row').empty().append(
            reportChannelTable.renderCollectionList(channelCollection, reportChannelTableProperties).$el
        );
    }
}




// WEBPACK FOOTER //
// ./srv/public/js/views/account/reports/ReportDetailViews.ts